<template>
    <section class="vuex-wrapper" :class="{active: isLoad}">
        <section class="vuex-product" v-if="page === 'product'">
            <Product />
        </section>
        <section class="vuex-cart" v-if="page === 'cart'">
            <Cart />
        </section>
        <section class="vuex-checkout" v-if="page === 'checkout'">
            <Checkout />
        </section>
    </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import Product from './components/pages/Product.vue'
import Cart from './components/pages/Cart.vue'
import Checkout from './components/pages/Checkout.vue'

const store = useStore()

const isLoad = ref(true)
const show = ref(false)
const animation = ref('')
const types = [
    'zoom', 'fade', 'flip', 'door', 'rotate',
    'slideUp', 'slideDown', 'slideLeft', 'slideRight'
]

// (window.innerHeight - 440) / 2  как computed строка
const paddingTop = computed(() =>
    `paddingTop: ${(window.innerHeight - 440) / 2}px`
)

onMounted(() => {
    store.dispatch('initSettings')
})

function delay(index) {
    return `
    animationDelay: ${index * 100}ms;
    WebkitAnimationDelay: ${index * 100}ms;
  `
}
function onShow(anim) {
    animation.value = anim
    show.value = true
}

const page = computed(() => store.getters.getSettings.pageName)
</script>
